const toggleHistoryEl = document.querySelector('.js-toggle-history');
const fullHistoryEl = document.querySelector('.js-full-history');

if (toggleHistoryEl && fullHistoryEl) {
  toggleHistoryEl.addEventListener('click', (e) => {
    e.preventDefault();

    toggleHistoryEl.classList.toggle('is-active');
    fullHistoryEl.classList.toggle('is-visible');
  })
}